module.exports = __webpack_public_path__ + "4168496cc153e3a125e284d3cbae6d20.jpg";